export default "__VITE_ASSET__C1i1YIJU__"